<template>
  <div class="title-view">
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue"

export default defineComponent({
  name: "TitleView",
})
</script>

<!-- Style -->
<style lang="scss" scoped>
@import "@/styles/variables.scss";

.title-view {
  margin-bottom: 10px;
  margin-top: $title-margin-top;
  font-size: 38px;
  font-family: $font-family-title;
  font-weight: bold;
  color: $title-default-color;
  text-align: left;
  line-height: 64px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
</style>
